export default __webpack_public_path__ + "static/premium-banner-img-desktop-min-50b23fa05de0b8844b3d2626c9a8fe35.png";